import { Injectable } from "@angular/core";
import { CustomerDto } from "@sharedcommon/model/organization/customer.model";
import { CustomerFilterDto } from "@sharedcommon/model/organization/filter/customer-filter.model";
import { SharedPagedResponse } from "@sharedcommon/model/shared-paged-response.model";
import { NeqHttpClient } from "@sharedcommon/rest/http-client.config";
import { OrganizationApiUrlUtil } from "@sharedcommon/util/organization-api-url.util";
import { Observable } from "rxjs";

@Injectable({ providedIn: 'root' })
export class CustomerRestService {

  constructor(protected neqHttpClient: NeqHttpClient) {}
  
  /**
   * Search customer
   * Response code 200 - filters customer
   * Response code 500 - Error
   * HTTP GET /customer/search
   * Java method: com.neovia.services.organization.controller.CustomerController.search()
   */
  search(filterDto: CustomerFilterDto): Observable<SharedPagedResponse<CustomerDto>> {
    return this.neqHttpClient.request({ method: 'GET', url: OrganizationApiUrlUtil.formatApiUrl("customer/search"), data: filterDto });
  }
  
  /**
   * Search customer
   * Response code 200 - found customer
   * Response code 404 - customer not found
   * Response code 500 - Error
   * HTTP GET /customer/{code}
   * Java method: com.neovia.services.organization.controller.CustomerController.getCustomer()
   */
  getByCode(code: string): Observable<CustomerDto> {
    return this.neqHttpClient.request({ method: 'GET', url: OrganizationApiUrlUtil.formatApiUrl(`customer/${code}`)});
  }

  /**
   * Search customer by entity code
   * Response code 200 - paged response of customers
   * Response code 500 - Error
   * HTTP GET entity/{entityCode}/customer/search
   * Java method: com.neovia.services.organization.controller.EntityController.searchSuppliersByEntityCode()
   */
  searchByEntityCode(entityCode: string, filterDto: CustomerFilterDto): Observable<SharedPagedResponse<CustomerDto>> {
    return this.neqHttpClient.request({ method: 'GET', url: OrganizationApiUrlUtil.formatApiUrl(`entity/${entityCode}/customer/search`), data: filterDto });
  }
}